<template>
  <div
    class="fe-flex fe-items-center fe-text-body-xxs fe-text-primary-grey-80 lg:fe-text-body-s"
  >
    <JdsIcon
      name="VerifiedIcon"
      smSize="s"
      lgSize="m"
      color="fe-text-success-50"
      className="fe-mr-xxs"
    />
    <div>
      <slot>Verified Purchase</slot>
    </div>
  </div>
</template>

<script>
  import JdsIcon from "@/components/DesignSystem/JdsIcon/JdsIcon.vue"

  export default {
    name: "VerifiedPurchase",
    components: { JdsIcon },
  }
</script>
